// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  alogList:[],
  alogPage:1,
  alogSize:10,
  alogTotal:0,
  alogById:{},
  alogModalType:"create",
  alogModalVisible:false,
  currentAlog:{},
  getAlogListPending: false,
  getAlogListError: null,
  submitAlogPending: false,
  submitAlogError: null,
  deleteAlogPending: false,
  deleteAlogError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/alog/redux/initialState.js